import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var firebaseConfig = {
  apiKey: 'AIzaSyB0LbvFE1qbOqvIULA8P_41m77mIdHyOow',
  authDomain: 'firegram-50b55.firebaseapp.com',
  projectId: 'firegram-50b55',
  storageBucket: 'firegram-50b55.appspot.com',
  messagingSenderId: '916622341886',
  appId: '1:916622341886:web:c11ad5df8d845afc2b17af'
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

//To connect to firebase storage
const projectStorage = firebase.storage();

//To connect with firebase database
const projectFirebase = firebase.firestore();

//Firebase timestamps
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

//So that you can use it in your app
export { projectStorage, projectFirebase, timestamp };
